export const BASE_API_URL = "https://beautysalon-backend-bjv5.onrender.com";

//import { BASE_API_URL } from "../api"; // Импорт базового URL

//axios.get(`${BASE_API_URL}/api/appointments/admin/all`, {
//    headers: { Authorization: `Bearer ${token}` },
//  })
